import { jsx, css } from '@emotion/react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import Fieldset from '../input-elements/oc-fieldset';

const FormGroup = ({columns, multipleFields, margin, children}) => {

	return (
		<Fieldset multipleFields={multipleFields} columns={columns} margin={margin}>
			{children}
		</Fieldset>
	)
}

export default FormGroup;

FormGroup.propTypes = {
	/** Set to true if you want a 2 column setup */
  columns: PropTypes.bool,
  /** Set to true if contains more than 1 field (example: multiple input fields). Set to false if only contains a checkbox or radio button group */
  multipleFields: PropTypes.bool,
  /** the group of fields you want to include */
  children: PropTypes.node,
  /** set margin for multiple form groups */
  margin: PropTypes.string,
}